import {ElementRef} from "@angular/core";

/**
 * Картки #965, #989: підсвітка рядків, на які вказав помічник кабінету (команда highlight, AssistantActionsService).
 *
 * Сторінка тримає один екземпляр: у шаблоні - [class.assistant-highlight]="highlight.has(id)" на рядку, в обробнику
 * команди - set(ids), а коли на екрані свіжі дані - ready(): прокрутка до першого підсвіченого рядка, один раз на set().
 * Дані ще вантажаться - сторінка викликає ready(), коли вони прийдуть; рядків на сторінці немає - нічого не прокручуємо.
 *
 * Підсвітка не гасне сама (#989): тримається, поки помічник не надішле новий набір (set замінює старий) чи сторінку не
 * закрили (destroy; новий екземпляр сторінки - без підсвітки). Список перечитали з іншим вмістом - клас рахується по
 * id заново: рядків, яких немає, не підсвічено, ті самі - лишаються підсвіченими.
 */
export class AssistantHighlight {
  private ids = new Set<number>();
  private scrollPending = false;
  private destroyed = false;

  constructor(private host: ElementRef<HTMLElement>) {
  }

  /** Що підсвітити (id товарів чи номери замовлень) замість попереднього набору; прокрутка - у ready() */
  set(ids: unknown): void {
    this.ids = new Set(Array.isArray(ids) ? ids.map(Number).filter((id) => Number.isInteger(id) && id > 0) : []);
    this.scrollPending = this.ids.size > 0;
  }

  has(id: unknown): boolean {
    return this.ids.size > 0 && this.ids.has(Number(id));
  }

  /** Дані сторінки показано: прокрутити до першого підсвіченого рядка (після відмальовки); підсвітку не чіпає */
  ready(): void {
    if (!this.scrollPending) {
      return;
    }

    this.scrollPending = false;

    setTimeout(() => {
      if (this.destroyed) {
        return;
      }

      this.host.nativeElement.querySelector('.assistant-highlight')?.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
  }

  destroy(): void {
    this.destroyed = true;
    this.ids = new Set();
    this.scrollPending = false;
  }
}
